'use strict';

angular.module('mean.trades').controller('TradeBidRequestEditOptionsController', ['$scope', 'MeanUser', 'Global', 'Bids', '$filter', 'Units', '$q', 'toaster', 'NotifyService', 'BidRequestEdit', '$location', 'Materials', 'Equipments', 'bidPlanCodeService', 'tradeCodeService', 'taskTotalsService', 'Trades', 'userService', 'Subtasks', 'TradeBids', 'ngDialog', 'bidTotalsService', 'bidRequestEditService', 'tradeService', 'tradeOptionsService', 'taskListService', 'Options', 'GeneralTasks', 'aceUtils',
  function($scope, MeanUser, Global, Bids, $filter, Units, $q, toaster, NotifyService, BidRequestEdit, $location, Materials, Equipments, bidPlanCodeService, tradeCodeService, taskTotalsService, Trades, userService, Subtasks, TradeBids, ngDialog, bidTotalsService, bidRequestEditService, tradeService, tradeOptionsService, taskListService, Options, GeneralTasks, aceUtils) {
    $scope.global = Global;

    $scope.user = MeanUser.user;

    $scope.plans = [];
    $scope.available_materials = [];
    $scope.available_categories = [];
    $scope.available_equipments = [];
    $scope.available_equipment_categories = [];
    $scope.original_bid_subtasks = [];
    $scope.unitEditing = false;
    $scope.matrix_values = [];
    $scope.all_tasks = [];
    $scope.materialEditId = -1;
    $scope.equipmentEditId = -1;
    $scope.main_account_id = null;

    Units.query({}, function(units) {
        $scope.units = units
    });

    $scope.init = function() {
        $scope.bid = BidRequestEdit.get();

        console.log('in the options init and have the bid');

        if(!$scope.bid || !$scope.bid._id){
            $location.path('home');
            return;
        }

        _.each($scope.bid.plan_codes, function(item) {
            $scope.plans.push(item.code);
        });

        taskListService.getByTrade(
            tradeCodeService.getCode($scope.user.trade[0]))
            .then(function(results) {
            $scope.available_tasks = results
        });

        userService.getMainAccount($scope.user.username).then(function(main_user) {
            $scope.main_account_id = main_user._id;
            TradeBids.query({'bid_id': $scope.bid._id,
                'username': main_user.username}, function(trade_bid) {
                $scope.my_bid = trade_bid[0];

                Options.query({'type': 'TradeOptions',
                    'bid_id': $scope.bid._id,
                    'trade_id': $scope.my_bid._id}, function(my_options) {
                    if(my_options.length === 0) {
                        toaster.pop('warning', 'Bid Options', 'Options not created by builder.');
                        return;
                    } else if(my_options.length === 1) {
                        $scope.my_options = my_options[0];
                    } else {
                        toaster.pop('error', 'Bid Options', 'Too many options returned.  Contact admin');
                        return;
                    }

                    Trades.query({'main_account_id': main_user._id}, function(trade) {
                        if(trade.length !== 1) return;

                        $scope.my_trade = trade[0];

                        if(!$scope.my_bid.costs) {
                            $scope.my_bid.costs = $scope.my_trade.costs;
                        }

                        $scope.my_options.options = tradeOptionsService.filterTrade(
                            $scope.my_options.options, $scope.user.trade[0]);

                        for(var i=0; i<$scope.my_options.options.length; i++) {
                            $scope.selectCurrentOption($scope.my_options.options[i]);
                            for(var j=0; j<$scope.plans.length; j++) {
                                $scope.buildPlan($scope.plans[j], $scope.my_options.options[i]);
                            }
                        }

                        // $scope.bid_list = taskTotalsService.mergeBidAndTaskList(
                        //     $scope.plans,
                        //     tradeCodeService.getCode($scope.user.trade[0]),
                        //     $scope.my_bid.task_list,
                        //     $scope.my_bid.bid,
                        //     $scope.my_bid.costs);

                        // for(var i=0; i<$scope.my_options.options.length; i++) {
                        //     //$scope.selectCurrentOption($scope.my_options.options[i]);
                        //     for(var j=0; j<$scope.plans.length; j++) {
                        //         $scope.myPlan($scope.plans[j], $scope.my_options.options[i]);
                        //     }
                        // }

                        // taskTotalsService.getCalculations(
                        //     $scope.bid_list,
                        //     $scope.my_bid.costs);

                        // $scope.original_bid_subtasks =
                        //     tradeOptionsService.getBidSubtasks(
                        //         $scope.my_bid, $scope.bid_list);

                        if($scope.my_bid.supplier) {
                            $scope.getMaterial();
                        }

                        if($scope.my_bid.equipment_supplier) {
                            $scope.getEquipment();
                        }

                        GeneralTasks.query({
                            'trade': tradeCodeService.getCode($scope.user.trade[0]),
                            'projectType': $scope.bid.projectType,
                            'geoLocation': $scope.bid.geoLocation,
                            'isCustom': $scope.bid.isCustom || false,
                            'userId': $scope.bid.userId || ''
                            },
                            function(tasks) {

                            $scope.all_tasks = $filter('orderBy')(tasks, 'order');

                            for(var i=0; i<$scope.all_tasks.length; i++) {
                                var subs = $filter('filter')($scope.my_trade.subtasks,
                                    {'task': $scope.all_tasks[i].task}, true);

                                $scope.all_tasks[i].subtasks = subs;
                            }
                        });

                        $scope.current_option = {};
                    });
                });
            });
        });
    };

    $scope.buildPlan = function(plan, item) {
        var inlist = $filter('filter')($scope.matrix_values, {
            'number': item.number}, true);
        if(inlist.length === 0) {
            $scope.matrix_values.push({
                number: item.number,
                name: item.name,
                description: item.description,
                plans: []
            });

            $scope.matrix_values[$scope.matrix_values.length-1].plans.push({
                plan: plan,
                option: 0,
                original: 0,
                value: 0
            });

        } else if(inlist.length === 1) {
            var has_plan = $filter('filter')(inlist[0].plans, {
                'plan': plan }, true);

            if(has_plan.length === 0) {
                inlist[0].plans.push({
                    plan: plan,
                    option: 0,
                    original: 0,
                    value: 0
                });
            }
        }
    };

    $scope.myPlan = function(plan, item) {
        var value = item.plans.indexOf(plan) !== -1;
        console.log('plan ' + plan + ', option ' + item.number + ', truthy: ' + (value));

        //var has_plan = {};
        var inlist = $filter('filter')($scope.matrix_values, {
            'number': item.number}, true);
        var has_plan = $filter('filter')(inlist[0].plans, {
            'plan': plan }, true);

        if(value && (has_plan.length === 1)) {
            var totals = {
                option: 0,
                original: 0
            }

            var bid_task = $filter('filter')($scope.bid_list, {
                'plan': plan }, true);

            _.each(bid_task, function(bid) {
                var option = $filter('filter')($scope.my_options.options, {
                    'number': item.number }, true);

                if(option.length === 1) {
                    _.each(option[0].subtasks, function(sub) {
                        if(bid.task === sub.task && sub.plan === plan) {
                            totals.option +=
                                sub.is_overridden?sub.overridden_total:sub.total;

                            if(sub.bid_subtask)
                                totals.original +=
                                    (bid.subtasks[sub.subtask_array_id]) ?
                                        bid.subtasks[sub.subtask_array_id].total : 0;
                        }
                    });
                }
            });

            has_plan[0].original = totals.original;
            has_plan[0].option = totals.option;
            has_plan[0].value = has_plan[0].option - has_plan[0].original;
        } else {
            has_plan[0].value = '-';
        }

        return has_plan;
    };

    $scope.getMaterial = function() {
        Materials.query({
            'trade_account': $scope.my_trade._id,
            'supplier': $scope.material_supplier,
            'userId': $scope.main_account_id
        }, function(materials) {
            $scope.available_materials = materials;
            $scope.available_materials.forEach(function(material, idx) {

                var in_list = $filter('filter')($scope.available_categories, {
                    name: material.category}, true);
                if(in_list.length === 0) {
                    $scope.available_categories.push({
                        name: material.category
                    });
                }
            });
        });
    }

    $scope.getEquipment = function() {
        Equipments.query({ 'trade_account': $scope.my_trade._id ,
                supplier: $scope.equipment_supplier}, function(equipments) {
            $scope.available_equipments = equipments;
            $scope.available_equipments.forEach(function(equipment, idx) {

                var in_list = $filter('filter')($scope.available_equipment_categories, {
                    name: equipment.category}, true);
                if(in_list.length === 0) {
                    $scope.available_equipment_categories.push({
                        name: equipment.category
                    });
                }
            });
        });
    };

    $scope.setTaskEditId =  function(pid) {
        $scope.taskEditId = pid;
    };

    $scope.setMaterialEditId =  function(pid) {
        $scope.materialEditId = pid;
    };

    $scope.setEquipmentEditId =  function(pid) {
        $scope.equipmentEditId = pid;
    };

    $scope.selectCurrentOption =  function(item) {
        var found = $filter('filter')($scope.my_options.options, {
            'number': item.number }, true);
        $scope.current_option = found[0];

        $scope.updateCurrentOption();
    };

    $scope.updateCurrentOption = function() {
        // tradeOptionsService.getOptionSubtasks(
        //     $scope.my_options,
        //     $scope.current_option);
    };

    $scope.onSubtaskSelect = function(selected_subtask) {
        $scope.current_subtask = selected_subtask;
    };

    $scope.getPlanQuantity = function(item, plan) {
        if($scope.current_option.plans.indexOf(plan) === -1) return;

        var option = $filter('filter')($scope.my_options.options, {
            'number': $scope.current_option.number }, true);

        if(option.length !== 1) {
            toaster.pop('error', 'Subtask Quantity',
                'Could not determin Quantity for ' + item.name);
            return 0;
        }

        var me = $filter('filter')(option[0].subtasks, {
            'plan': plan, 'time': item.time, task: item.task }, true);

        return (me[0]) ? me[0].quantity : 0;
    };

    $scope.updateTask = function(value, item, plan) {
        var option = $filter('filter')($scope.my_options.options, {
            'number': $scope.current_option.number }, true);

        if(option.length !== 1) {
            alert('Problem');
            return;
        }

        var sub = $filter('filter')(option[0].subtasks, {
            'plan': plan, 'time': item.time }, true);

        if(sub.length !== 1) {
            toaster.pop('error', 'No Subtask Found',
                'updateTask could not find a valid subtask to update.');
            return;
        }

        sub[0].quantity = Number(value);

        taskTotalsService.getSubtaskCalculations(
            sub,
            $scope.my_bid.costs);

        tradeOptionsService.stripId(sub[0]);

        $scope.my_options.$update(function(res) {
            $scope.updateCurrentOption();
            for(var j=0; j<$scope.plans.length; j++) {
                $scope.myPlan($scope.plans[j], $scope.current_option);
            }
            toaster.pop('success', 'Bid Database', 'Subtask Quantity Updated.');
        }, function(error) {
            toaster.pop('error', 'Bid Database', 'Problem saving the subtask quantity data.');
        });
    };

    $scope.editCurrentValue = function (item) {
        item.currentValueEditing = true;
    };

    $scope.doneEditingCurrentValue = function (item) {
        if(!item.currentValueEditing) return;

        var option = $filter('filter')($scope.my_options.options, {
            'number': $scope.current_option.number }, true);

        if(option.length !== 1) {
            alert('Problem');
            return;
        }

        var subs = $filter('filter')(option[0].subtasks, {
            'plan': item.plan }, true);

        var current_value = item.option - item.original;
        var amount = item.value - current_value;
        var time = new Date().getTime();
        var idx = option[0].plans.indexOf(item.plan);

        if(idx === -1) {
            toaster.pop('error', 'Option Plan',
                'Could not find plan in option.');
            return;
        }

        var plan = option[0].plans[idx];
        var task = angular.copy($scope.all_tasks[$scope.all_tasks.length-1]);
        var sub = angular.copy(task.subtasks[task.subtasks.length-1]);

        //we need to see if we've already added an override for this
        //plan.  If so, lets just update the number else add a new sub.
        var inlist = $filter('filter')(subs, {'code': sub.code,
            'is_overridden': true, 'plan': item.plan}, true);

        if(inlist.length === 0) {
            sub.active = false;
            sub.bid_hours = 0;
            sub.hours_allowed = 0;
            sub.is_overridden = true;
            sub.overridden_total = amount;
            sub.plan = plan;
            sub.quantity = 0;
            sub.subtask_array_id = task.subtasks.length-1;
            sub.time = time
            sub.total = 0;
            sub.trade_id = $scope.my_bid._id;
            delete sub._id;
            option[0].subtasks.push(sub);
        } else if(inlist.length === 1) {
            inlist[0].overridden_total += amount;
        } else {
            toaster.pop('error', 'Too Many Overrides Found',
                'Contact Admin');
            return;
        }

        $scope.my_options.$update(function(res) {
            //$scope.current_option = option[0];
            //$scope.updateCurrentOption();
            for(var j=0; j<$scope.plans.length; j++) {
                $scope.myPlan($scope.plans[j], $scope.current_option);
            }
            toaster.pop('success', 'Bid Database', 'Subtask Quantity Updated.');
        }, function(error) {
            toaster.pop('error', 'Bid Database', 'Problem saving the subtask quantity data.');
        });

        item.currentValueEditing = false;
    };

    $scope.editCrewRate = function (item) {
        item.crewRateEditing = true;
    };

    $scope.doneCrewRateEditing = function (item) {
        if(!item.crewRateEditing) return;

        $scope.updateSubtask(item);

        item.crewRateEditing = false;
    };

    $scope.editPieceRate = function (item) {
        if(item.piece_per_hour_rate !== 0) {
            alert('You must clear out Piece/Hour Rate first.');
            return;
        }

        item.crewPieceRateEditing = true;
    };

    $scope.donePieceRateEditing = function (item) {
        if(!item.crewPieceRateEditing) return;

        $scope.updateSubtask(item);

        item.crewPieceRateEditing = false;
    };

    $scope.editPiecePerHourRate = function (item) {
        if(item.piece_rate !== 0) {
            alert('You must clear out Piece Rate first.');
            return;
        }

        item.crewPiecePerHourRateEditing = true;
    };

    $scope.donePiecePerHourRateEditing = function (item) {
        if(!item.crewPiecePerHourRateEditing) return;

        $scope.updateSubtask(item);

        item.crewPiecePerHourRateEditing = false;
    };

    $scope.editUnits = function (item) {
        item.unitEditing = true;
    };

    $scope.doneUnitEditing = function (item) {
        if(!item.unitEditing) return;

        item.unitEditing = false;
        item.unit = item.unit.unit;
        $scope.updateSubtask(item);
    };

    $scope.updateSubtask = function(item) {
        if(!item.piece_per_hour_rate) item.piece_per_hour_rate = 0;
        if(!item.piece_rate) item.piece_rate = 0;

        var option = $filter('filter')($scope.my_options.options, {
            'number': $scope.current_option.number }, true);

        if(option.length !== 1) {
            alert('Problem');
            return;
        }

        var subs = $filter('filter')(option[0].subtasks, {
            'time': item.time }, true);

        _.each(subs, function(sub) {
            sub.crew_rate = Number(item.crew_rate);
            sub.piece_per_hour_rate = Number(item.piece_per_hour_rate);
            sub.piece_rate = Number(item.piece_rate);
            sub.piece_per_size = Number(item.piece_per_size);
            sub.unit = item.unit;
        });

        taskTotalsService.getSubtaskCalculations(
            subs,
            $scope.my_bid.costs);

        $scope.my_options.$update(function(res) {
            //$scope.updateCurrentOption();  this function is resetting current_subtask
            for(var j=0; j<$scope.plans.length; j++) {
                $scope.myPlan($scope.plans[j], $scope.current_option);
            }
            toaster.pop('success', 'Bid Database', 'Subtask Updated.');
        }, function(error) {
            toaster.pop('error', 'Bid Database', 'Problem saving the subtask data.');
        });
    };

    $scope.addBidSubtask = function(selected_subtask) {
        if(!$scope.current_option || !$scope.current_option.plans) {
            toaster.pop('warning', 'Option Not Selected',
                'You must select an option before adding a subtask');
            return;
        }

        var option = $filter('filter')($scope.my_options.options, {
            'number': $scope.current_option.number }, true);

        if(option.length !== 1) {
            toaster.pop('error', 'Option Not Returning',
                'Did not find the option needed.  Contact admin.');
            return;
        }

        var bids = $filter('filter')($scope.bid_list, {
            'task': selected_subtask.task,
            'trade': selected_subtask.trade}, true);

        var time = new Date().getTime();

        _.each(bids, function(bid) {
            if(option[0].plans.indexOf(bid.plan) !== -1) {
                _.each(bid.subtasks, function(subtask) {
                    if(subtask._id === selected_subtask._id) {
                        option[0].subtasks.push(angular.copy(subtask));
                        option[0].subtasks[option[0].subtasks.length-1].plan = bid.plan;
                        option[0].subtasks[option[0].subtasks.length-1].trade_id = $scope.my_bid._id;
                        option[0].subtasks[option[0].subtasks.length-1].time = time;
                        option[0].subtasks[option[0].subtasks.length-1].subtask_array_id = subtask._id;
                        option[0].subtasks[option[0].subtasks.length-1].bid_subtask = true;
                        _.each(subtask.materials, function(material, i) {
                            option[0].subtasks[option[0].subtasks.length-1].materials[i].material_id = material._id;
                        });
                        _.each(subtask.equipment, function(equipment, i) {
                            option[0].subtasks[option[0].subtasks.length-1].equipment[i].equipment_id = equipment._id;
                        });
                        tradeOptionsService.stripId(option[0].subtasks[option[0].subtasks.length-1]);
                    }
                });
            }
        });

        $scope.my_options.$update(function(res) {
            $scope.current_option = option[0];
            $scope.updateCurrentOption();
            for(var j=0; j<$scope.plans.length; j++) {
                $scope.myPlan($scope.plans[j], $scope.current_option);
            }
            toaster.pop('success', 'Option Saved', 'Option saved to database');
        }, function(error) {
            toaster.pop('error', 'Option Save Error', error);
        });

        this.selected_subtask = '';
    };

    $scope.removeTaskOption = function(item) {
        console.log('removeTaskOption');
        if(!$scope.current_option || !$scope.current_option.plans) {
            toaster.pop('warning', 'Option Not Selected',
                'You must select an option before removing a subtask');
            return;
        }

        var option = $filter('filter')($scope.my_options.options, {
            'number': $scope.current_option.number }, true);

        if(option.length !== 1) {
            toaster.pop('error', 'Option Not Returning',
                'Did not find the option needed.  Contact admin.');
            return;
        }

        var list_item = $filter('filter')(option[0].subtasks, {
            'time': item.time }, true);

        for(var i=list_item.length-1; i>=0; i--) {
            var idx = option[0].subtasks.indexOf(list_item[i]);
            option[0].subtasks.splice(idx, 1);
        }

        $scope.my_options.$update(function(res) {
            $scope.current_option = option[0];
            $scope.updateCurrentOption();
            //$scope.my_options.options.push(res);
            for(var j=0; j<$scope.plans.length; j++) {
                $scope.myPlan($scope.plans[j], $scope.current_option);
            }
            toaster.pop('success', 'Option Saved', 'Option saved to database');
        }, function(error) {
            toaster.pop('error', 'Option Save Error', error);
        });
    };

    $scope.addSystemSubtask = function(sub) {
        if(!$scope.current_option) {
            toaster.pop('warning', 'Option Not Selected',
                'You must select an option before adding a subtask');
            return;
        }

        var option = $filter('filter')($scope.my_options.options, {
            'number': $scope.current_option.number }, true);

        if(option.length !== 1) {
            toaster.pop('error', 'Option Not Returning',
                'Did not find the option needed.  Contact admin.');
            return;
        }

        //sub is the system subtask but we need to see if we have an
        //overridden subtask in our tradeBid.
        var inlist = $filter('filter')($scope.my_trade.subtasks, {
            'subtask_id': sub._id}, true);

        // get the task from the system task list
        var task_item = $filter('filter')($scope.all_tasks, {
            'trade': sub.trade, 'task': sub.task }, true);

        if(task_item.length !== 1) {
            toaster.pop('error', 'Problem Getting Task',
                'Could not get task from task_list.  Contact Admin.');
            return;
        }

        var sub_index = task_item[0].subtasks.indexOf(sub);

        var time = new Date().getTime();
        var value = {};
        if(inlist.length === 1) {
            value = {
                _id: task_item[0].subtasks.length,
                trade_id: $scope.my_bid._id,
                code: sub.code,
                time: time,
                trade: sub.trade,
                task: sub.task,
                name: sub.name,
                unit: sub.unit,
                subtask_id: inlist[0].subtask_id,
                piece_rate: inlist[0].piece_rate,
                crew_rate: inlist[0].crew_rate,
                piece_per_hour_rate: inlist[0].piece_per_hour_rate,
                quantity: 0,
                bid_hours: 0,
                hours_allowed: 0,
                total: 0,
                bid_total: 0
            }
        } else {
            value = {
                _id: task_item[0].subtasks.length,
                trade_id: $scope.my_bid._id,
                code: sub.code,
                time: time,
                trade: sub.trade,
                task: sub.task,
                name: sub.name,
                unit: sub.unit,
                subtask_id: sub._id,
                piece_rate: sub.piece_rate,
                crew_rate: sub.crew_rate,
                piece_per_hour_rate: sub.piece_per_hour_rate,
                quantity: 0,
                bid_hours: 0,
                hours_allowed: 0,
                total: 0,
                bid_total: 0
            }
        }

        _.each(option[0].plans, function(plan) {
            option[0].subtasks.push(angular.copy(value));
            option[0].subtasks[option[0].subtasks.length-1].plan = plan;
            option[0].subtasks[option[0].subtasks.length-1].subtask_array_id = sub_index;

            tradeOptionsService.stripId(option[0].subtasks[option[0].subtasks.length-1]);
        });

        $scope.my_options.$update(function(res) {
            $scope.current_option = option[0];
            $scope.updateCurrentOption();
            for(var j=0; j<$scope.plans.length; j++) {
                $scope.myPlan($scope.plans[j], $scope.current_option);
            }
            toaster.pop('success', 'Option Saved', 'Option saved to database');
        }, function(error) {
            toaster.pop('error', 'Option Save Error', error);
        });

        this.selected_subtask = '';
    };

    $scope.onSupplierSelect = function(new_supplier) {
        $scope.overridden_materials = $filter('filter')($scope.all_materials, { supplier: new_supplier.name }, true);
        $scope.overridden_categories = [];

        $scope.overridden_materials.forEach(function(material, idx) {
            var in_list = $filter('filter')($scope.overridden_categories, {name: material.category}, true);
            if(in_list.length === 0) {
                $scope.overridden_categories.push({
                    name: material.category
                });
            }
        });
    };

    $scope.onEquipmentSupplierSelect = function(new_supplier) {
        $scope.overridden_equipments = $filter('filter')($scope.all_equipments, { supplier: new_supplier.name }, true);
        $scope.overridden_equipment_categories = [];

        $scope.overridden_equipments.forEach(function(equipment, idx) {
            var in_list = $filter('filter')($scope.overridden_equipment_categories, {name: equipment.category}, true);
            if(in_list.length === 0) {
                $scope.overridden_equipment_categories.push({
                    name: equipment.category
                });
            }
        });
    };

    $scope.deleteMaterial = function(material, index){
        var option = $filter('filter')($scope.my_options.options, {
            'number': $scope.current_option.number }, true);

        if(option.length !== 1) {
            alert('Problem');
            return;
        }

        var mat_index = $scope.current_subtask.materials.indexOf(material);

        var subs = $filter('filter')(option[0].subtasks, {
            'time': $scope.current_subtask.time }, true);

        _.each(subs, function(sub) {
            sub.materials.splice(mat_index, 1);
        });

        taskTotalsService.getSubtaskCalculations(
            subs,
            $scope.my_bid.costs);

        $scope.my_options.$update(function(res) {
            $scope.current_option = option[0];
            $scope.updateCurrentOption();
            for(var j=0; j<$scope.plans.length; j++) {
                $scope.myPlan($scope.plans[j], $scope.current_option);
            }
            toaster.pop('success', 'Bid Database', 'Subtask Updated.');
        }, function(error) {
            toaster.pop('error', 'Bid Database', 'Problem saving the subtask data.');
        });

        $scope.materialEditId = -1;
    };

    $scope.addMaterial = function(material) {
        if(!material) {
            alert('No Material Selected!');
            return;
        }

        var new_mat = ({
            name: material.name,
            supplier: material.supplier,
            description: material.description,
            unit: material.unit.unit,
            trade: material.trade,
            note: material.note,
            units_per_order: Number(material.units_per_order),
            price_per_order: material.price_per_order,
            piece_per_size: material.piece_per_size,
            delivery_price: material.delivery_price,
            delivery_offset: material.delivery_offset,
            quantity: 0,
            quantity_allowed: 0,
            price_per_order: material.price_per_order,
            piece_per_size: material.piece_per_size,
            delivery_price: material.delivery_price,
            note: material.note,
            isInventory: material.isInventory || false
        });

        var option = $filter('filter')($scope.my_options.options, {
            'number': $scope.current_option.number }, true);

        if(option.length !== 1) {
            alert('Problem');
            return;
        }

        var subs = $filter('filter')(option[0].subtasks, {
            'time': $scope.current_subtask.time }, true);

        _.each(subs, function(sub) {
            sub.materials.push(new_mat);
        });

        taskTotalsService.getSubtaskCalculations(
            subs,
            $scope.my_bid.costs);

        $scope.my_options.$update(function(res) {
            $scope.current_option = option[0];
            $scope.updateCurrentOption();
            for(var j=0; j<$scope.plans.length; j++) {
                $scope.myPlan($scope.plans[j], $scope.current_option);
            }
            toaster.pop('success', 'Material Added', 'Subtask Updated.');
        }, function(error) {
            toaster.pop('error', 'Material Not Added', error);
        });

        $scope.materialEditId = -1;

        this.current_material = this.current_category = '';
        if(this.current_material)
          this.current_material.note = '';

        this.new_supplier = this.new_category = this.new_material = '';
    };

    $scope.updateMaterial = function(undef, material) {
        // material represents one of possibly many due
        // to the view.  We only show one subtask but
        // there can be many so we have to look at our
        // original options and then pull subtasks that
        // match our current subtask
        var option = $filter('filter')($scope.my_options.options, {
            'number': $scope.current_option.number }, true);

        if(option.length !== 1) {
            alert('Problem');
            return;
        }

        var mat_index = $scope.current_subtask.materials.indexOf(material);

        var subs = $filter('filter')(option[0].subtasks, {
            'time': $scope.current_subtask.time }, true);

        _.each(subs, function(sub) {
            sub.materials[mat_index].piece_per_size = Number(material.piece_per_size);
            sub.materials[mat_index].price_per_order = material.price_per_order;
            sub.materials[mat_index].note = material.note;
            sub.materials[mat_index].unit = (material.unit.unit) ? material.unit.unit : material.unit;
        });

        taskTotalsService.getSubtaskCalculations(
            subs,
            $scope.my_bid.costs);

        $scope.my_options.$update(function(res) {
            $scope.current_option = option[0];
            //$scope.updateCurrentOption();  this function is resetting current_subtask
            for(var j=0; j<$scope.plans.length; j++) {
                $scope.myPlan($scope.plans[j], $scope.current_option);
            }
            toaster.pop('success', 'Bid Database', 'Subtask Updated.');
        }, function(error) {
            toaster.pop('error', 'Bid Database', 'Problem saving the subtask data.');
        });

        $scope.materialEditId = -1;
    };

    $scope.supplierModalActivated = function() {
        if(!$scope.available_suppliers) {
            $scope.available_suppliers = [];

            Materials.query({
                'trade_account': $scope.my_trade._id,
                'userId': $scope.main_account_id
             }, function(materials) {
                $scope.all_materials = materials;
                $scope.all_materials.forEach(function(material, idx) {

                    var in_list = $filter('filter')($scope.available_suppliers, {
                        name: material.supplier}, true);
                    if(in_list.length === 0) {
                        $scope.available_suppliers.push({
                            name: material.supplier
                        });
                    }
                });
            });
        }
    };

    $scope.deleteEquipment = function(equipment, index){
        console.log('deleteEquipment commented out');
        var option = $filter('filter')($scope.my_options.options, {
            'number': $scope.current_option.number }, true);

        if(option.length !== 1) {
            alert('Problem');
            return;
        }

        var eq_index = $scope.current_subtask.equipment.indexOf(equipment);

        var subs = $filter('filter')(option[0].subtasks, {
            'time': $scope.current_subtask.time }, true);

        _.each(subs, function(sub) {
            sub.equipment.splice(eq_index, 1);
        });

        taskTotalsService.getSubtaskCalculations(
            subs,
            $scope.my_bid.costs);

        $scope.my_options.$update(function(res) {
            $scope.current_option = option[0];
            $scope.updateCurrentOption();
            for(var j=0; j<$scope.plans.length; j++) {
                $scope.myPlan($scope.plans[j], $scope.current_option);
            }
            toaster.pop('success', 'Bid Database', 'Subtask Updated.');
        }, function(error) {
            toaster.pop('error', 'Bid Database', 'Problem saving the subtask data.');
        });

        $scope.equipmentEditId = -1;
    };

    $scope.addEquipment = function(equipment) {
        if(!equipment) {
            alert('No Equipment Selected!');
            return;
        }

        var new_mat = ({
            name: equipment.name,
            supplier: equipment.supplier,
            description: equipment.description,
            unit: equipment.unit.unit,
            trade: equipment.trade,
            note: equipment.note,
            units_per_order: Number(equipment.units_per_order),
            price_per_order: equipment.price_per_order,
            piece_per_size: equipment.piece_per_size,
            delivery_price: equipment.delivery_price,
            delivery_offset: equipment.delivery_offset,
            quantity: 0,
            quantity_allowed: 0,
            price_per_order: equipment.price_per_order,
            piece_per_size: equipment.piece_per_size,
            delivery_price: equipment.delivery_price,
            note: equipment.note
        });

        var option = $filter('filter')($scope.my_options.options, {
            'number': $scope.current_option.number }, true);

        if(option.length !== 1) {
            alert('Problem');
            return;
        }

        var subs = $filter('filter')(option[0].subtasks, {
            'time': $scope.current_subtask.time }, true);

        _.each(subs, function(sub) {
            sub.equipment.push(new_mat);
        });

        taskTotalsService.getSubtaskCalculations(
            subs,
            $scope.my_bid.costs);

        $scope.my_options.$update(function(res) {
            $scope.current_option = option[0];
            $scope.updateCurrentOption();
            for(var j=0; j<$scope.plans.length; j++) {
                $scope.myPlan($scope.plans[j], $scope.current_option);
            }
            toaster.pop('success', 'Equipment Added', 'Subtask Updated.');
        }, function(error) {
            toaster.pop('error', 'Equipment Not Added', error);
        });

        $scope.equipmentEditId = -1;

        this.current_equipment = this.current_category = '';
        if(this.current_equipment)
          this.current_equipment.note = '';

        this.new_supplier = this.new_category = this.new_equipment = '';
    };

    $scope.updateEquipment = function(undef, equipment) {
        // material represents one of possibly many due
        // to the view.  We only show one subtask but
        // there can be many so we have to look at our
        // original options and then pull subtasks that
        // match our current subtask
        var option = $filter('filter')($scope.my_options.options, {
            'number': $scope.current_option.number }, true);

        if(option.length !== 1) {
            alert('Problem');
            return;
        }

        var eq_index = $scope.current_subtask.equipment.indexOf(equipment);

        var subs = $filter('filter')(option[0].subtasks, {
            'time': $scope.current_subtask.time }, true);

        _.each(subs, function(sub) {
            sub.equipment[eq_index].piece_per_size = Number(equipment.piece_per_size);
            sub.equipment[eq_index].price_per_order = equipment.price_per_order;
            sub.equipment[eq_index].note = equipment.note;
            sub.equipment[eq_index].unit = (equipment.unit.unit) ? equipment.unit.unit : equipment.unit;
        });

        taskTotalsService.getSubtaskCalculations(
            subs,
            $scope.my_bid.costs);

        $scope.my_options.$update(function(res) {
            $scope.current_option = option[0];
            //$scope.updateCurrentOption();  this function is resetting current_subtask
            for(var j=0; j<$scope.plans.length; j++) {
                $scope.myPlan($scope.plans[j], $scope.current_option);
            }
            toaster.pop('success', 'Bid Database', 'Subtask Updated.');
        }, function(error) {
            toaster.pop('error', 'Bid Database', 'Problem saving the subtask data.');
        });

        $scope.equipmentEditId = -1;
    };

    $scope.equipmentSupplierModalActivated = function() {
        if(!$scope.all_equipments) {
            $scope.all_equipments = [];
            $scope.available_equipment_suppliers = [];

            Equipments.query({ 'trade_account': $scope.my_trade._id }, function(equipments) {
                $scope.all_equipments = equipments;
                $scope.all_equipments.forEach(function(equipment, idx) {

                    var in_list = $filter('filter')($scope.available_equipment_suppliers, {name: equipment.supplier}, true);
                    if(in_list.length === 0) {
                        $scope.available_equipment_suppliers.push({
                            name: equipment.supplier
                        });
                    }
                });
            });
        }
    };

    $scope.editRequest = function() {
        BidRequestEdit.set($scope.bid);
    };
  }
]);



// WEBPACK FOOTER //
// ./packages/custom/trades/public/controllers/tradeBidRequestEditOptions.js